import styled from "styled-components";
import colours from "../../assets/colours";

export const UnitsWrapper = styled.div`
  display: flex;
  gap: 10px;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex-grow: 1;
`;

export const Unit = styled.button<{ active: boolean }>`
  border: none;
  outline: none;
  cursor: pointer;
  padding: 10px;
  border-radius: 5px;
  text-align: center;
  flex-grow: 1;
  height: 56px;
	margin: 2px 0;
  background-color: ${({ active }) => (active ? colours.darkBlue : "#fff")};
  color: ${({ active }) => (active ? "#fff" : colours.darkBlue)};
  &:hover {
    background-color: ${colours.blueMedium};
    color: #fff;
  }
`;
